module.exports = __webpack_public_path__ + "static/media/city_2.1abd20cd.jpg";